import { createContext, useContext, Dispatch, SetStateAction } from 'react'

type SetTheme = Dispatch<SetStateAction<string>>

export const SetThemeContext = createContext<SetTheme | null>(null)

export const useSetTheme = () => {
  return useContext(SetThemeContext) as SetTheme
}
